.table {
  table-layout: fixed;
  border: none;
}

.loader {
  height: 200px;
}
